import CheckboxGroupField from './CheckboxGroupField.component';

export default CheckboxGroupField;
